import {Component, ElementRef, EventEmitter, HostBinding, Input, Output} from '@angular/core';
import {FolderComponentObject, FolderComponentObjects} from '../../../../classes/folder-component-object';
import {backButtonAnimation, selectedFolderContainerAnimation} from '../folder-selector-dialog.animations';

@Component({
  selector: 'app-folder-selector-dialog-breadcrumb',
  templateUrl: './folder-selector-dialog-breadcrumb.component.html',
  styleUrls: ['./folder-selector-dialog-breadcrumb.component.scss'],
  animations: [
    selectedFolderContainerAnimation,
    backButtonAnimation
  ]
})
export class FolderSelectorDialogBreadcrumbComponent {
  public backIsEnabled: boolean;

  @Input('backIsEnabled') public set _backIsEnabled(backIsEnabled: boolean) {
    this.backIsEnabled = backIsEnabled;
    this.selectedFolderContainer = backIsEnabled;
  }

  @Input() public path: FolderComponentObjects;
  @Input() public folder: FolderComponentObject;
  @Input() public showHelpText: boolean = true;

  @Output() public onFolderBack: EventEmitter<void> = new EventEmitter<void>();
  @Output() public onFolderSelect: EventEmitter<FolderComponentObject> = new EventEmitter<FolderComponentObject>();

  @HostBinding('@selectedFolderContainer') selectedFolderContainer: boolean;
}
